import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useInsertData } from "../../hooks/useInsertData";
import { useGetData } from "../../hooks/useGetData";
import { useUpdateData } from "../../hooks/useUpdateDate";
import useDeleteData from "../../hooks/useDeleteData";

export const createCompany = createAsyncThunk("company/createCompany", async (data, { rejectWithValue }) => {
  try {
    const res = await useInsertData("companies", data);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const getAllCompanies = createAsyncThunk("company/getAllCompanies", async (_, { rejectWithValue }) => {
  try {
    const res = await useGetData("companies");
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const getSpecificCompany = createAsyncThunk("company/getSpecificCompany", async (id, { rejectWithValue }) => {
  try {
    const res = await useGetData(`companies/${id}`);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const updateCompany = createAsyncThunk("company/updateCompany", async ({ data, id }, { rejectWithValue }) => {
  try {
    const res = await useUpdateData(`companies/${id}`, data);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const deleteCompany = createAsyncThunk("company/deleteCompany", async (id, { rejectWithValue }) => {
  try {
    const res = await useDeleteData(`companies/${id}`);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});

const initialState = {
  company: null,
  allCompanies: null,
  statusUpdateCompany: null,
  specificCompany: null,
  status: "idle",
  error: null,
  token: null,
};
export const companySlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCompany.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createCompany.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.company = action.payload;
      })
      .addCase(createCompany.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getAllCompanies.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllCompanies.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allCompanies = action.payload;
      })
      .addCase(getAllCompanies.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getSpecificCompany.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getSpecificCompany.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.specificCompany = action.payload;
      })
      .addCase(getSpecificCompany.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(updateCompany.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(updateCompany.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(deleteCompany.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteCompany.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(deleteCompany.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
    // //---------------------------------------
    // .addCase(resendCode.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(resendCode.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.resendCodeResponse = action.payload;
    // })
    // .addCase(resendCode.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(loginUser.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(loginUser.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.currentUser = action.payload.data;
    //   state.token = action.payload.token;
    // })
    // .addCase(loginUser.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(getCurrentUser.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(getCurrentUser.fulfilled, (state, action) => {
    //   state.currentUser = action.payload.user;
    //   state.status = "succeeded";
    // })
    // .addCase(getCurrentUser.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(forgetPassword.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(forgetPassword.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.forgetPasswordResponse = action.payload;
    // })
    // .addCase(forgetPassword.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(resetPassword.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(resetPassword.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.resetPasswordResponse = action.payload;
    // })
    // .addCase(resetPassword.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(updateUserData.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(updateUserData.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.user = action.payload;
    // })
    // .addCase(updateUserData.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // });
  },
});
export default companySlice.reducer;
